var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "s-layout",
    style: _vm.colorObject
  }, [_vm.isLoading ? _c('Loading', {
    attrs: {
      "loading-message": "載入中...",
      "background-color": '#ffffff'
    }
  }) : _vm._e(), _c('div', {
    staticClass: "s-container"
  }, [_c('div', [_c('Header', {
    attrs: {
      "page-title": _vm.getModuleConfig('page_title'),
      "page-image": _vm.getModuleConfig('page_image'),
      "page-kv-image": _vm.getModuleConfig('page_kv_image'),
      "header-section": _vm.getModuleConfig('header_section'),
      "meta": _vm.meta
    }
  }), _c('div', {
    staticClass: "page"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card__info"
  }, [_c('div', {
    staticClass: "card__title"
  }, [_vm._v(" " + _vm._s(_vm.displayText('record_title', '活動頁')) + " ")])])]), _c('div', [_c('h3', {
    staticClass: "text-center s-title py-2"
  }, [_vm._v(_vm._s(_vm.displayText('record_point_title', '消費紀錄')))])]), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card__info"
  }, [!_vm.getEventConfig('hide_record_customer') ? _c('div', {
    staticClass: "card__text py-1"
  }, [_c('b', [_vm._v(_vm._s(_vm.displayText('record_customer', '會員')))]), _vm._v(" " + _vm._s(_vm.user.name) + " ")]) : _vm._e(), !_vm.getEventConfig('hide_record_product_name') ? _c('div', {
    staticClass: "card_text py-1"
  }, [_c('b', [_vm._v(_vm._s(_vm.displayText('record_product_name', '商品名稱:')))]), _vm._v(" " + _vm._s(_vm.redeem_code.redeem_code_bundle.name) + " ")]) : _vm._e(), !_vm.getEventConfig('hide_record_product_no') ? _c('div', {
    staticClass: "card_text py-1"
  }, [_c('b', [_vm._v(_vm._s(_vm.displayText('record_product_no', '商品編號:')))]), _vm._v(" " + _vm._s(_vm.redeem_code.redeem_code_bundle.config.product_code) + " ")]) : _vm._e(), !_vm.getEventConfig('hide_record_redeem_code') ? _c('div', {
    staticClass: "card_text py-1"
  }, [_c('b', [_vm._v(_vm._s(_vm.displayText('record_redeem_code', '活動序號:')))]), _vm._v(" " + _vm._s(_vm.redeem_code.code) + " ")]) : _vm._e(), !_vm.getEventConfig('hide_record_redeem_date') ? _c('div', {
    staticClass: "card_text py-1"
  }, [_c('b', [_vm._v(_vm._s(_vm.displayText('record_redeem_date', '歸戶日期:')))]), _vm._v(" " + _vm._s(_vm.displayDate(_vm.redeem_code.redeem_at)) + " ")]) : _vm._e(), !_vm.getEventConfig('hide_record_point_text') ? _c('div', {
    staticClass: "card_text py-1"
  }, [_c('b', [_vm._v(_vm._s(_vm.displayText('record_point_text', '可獲得點數:')))]), _vm._v(" " + _vm._s(_vm.redeem_code.redeem_code_bundle.config.reward_points) + " 點 ")]) : _vm._e()])]), _c('div', {
    staticClass: "btn"
  }, [_c('MemberButton', {
    attrs: {
      "button-text": _vm.displayText('cancel_button_text', '返回官方帳號'),
      "button-url": _vm.displayText('cancel_button_url', ''),
      "type": _vm.displayText('cancel_button_action', 'CLOSE')
    }
  })], 1)])], 1)])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }